import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "banner-bg" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "home" }
const _hoisted_5 = { class: "home-content" }
const _hoisted_6 = { class: "first-level-title" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "secondary-title" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "product-child-box"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "product-img" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "product-text" }
const _hoisted_16 = { class: "product-title" }
const _hoisted_17 = { class: "more-box" }
const _hoisted_18 = { class: "qdfg" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "jjfa" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "red-line"
}
const _hoisted_23 = {
  key: 1,
  src: "/images/for-right.png"
}
const _hoisted_24 = {
  key: 2,
  class: "jjfa-list-text"
}
const _hoisted_25 = { class: "cgal" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "box2" }
const _hoisted_28 = ["src"]
const _hoisted_29 = ["src"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "box4" }
const _hoisted_32 = ["src"]
const _hoisted_33 = ["src"]
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "box6" }
const _hoisted_36 = ["src"]
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "box2" }
const _hoisted_40 = ["src"]
const _hoisted_41 = ["src"]
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "box4" }
const _hoisted_44 = ["src"]
const _hoisted_45 = ["src"]
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "kfhz" }
const _hoisted_48 = { class: "open-cooperation-box" }
const _hoisted_49 = { class: "xwzx" }
const _hoisted_50 = { class: "more-box" }
const _hoisted_51 = { class: "xwzx-box" }
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "news-content" }
const _hoisted_54 = ["onClick"]

import { ref, reactive, onMounted } from 'vue'
import { getProductTypes, addConsult, getProducts, selectCommonElement, getProductProfile, getProductList } from '@/api'
import OpenCooperation from '@/components/OpenCooperation.vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { asynchronousRetrieval } from '@/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const loadUrl: any = ref({})
const bannerList = ref([])
const router = useRouter()
const store = useStore()
const newsList: any = ref([])
const showProducts: any = ref([])
const stopMove = ref(false)
const productTypes: any = ref({})
// const activeProductIndex = ref(0)
const activeSolutionsIndex = ref(0)
const activeType = ref(1)
const activeProduct = ref(0)
const activeListIndex = ref(0)
let time = 0
let timer: any = null

// 解决方案枚举
const solutions: any = ref(
  [
    {
      name: "文娱",
      content:
        "全景景区导览、虚拟博物馆、虚实融合AR项目应用、商场儿童游乐项目体验、企业展厅、营销展示、虚拟数字人、虚拟直播",
    },
    {
      name: "工业",
      content:
        "设计评审、虚拟装配、维修维护、远程协助、技能培训、数字孪生、点巡检、工厂漫游",
    },
    {
      name: "教育",
      content:
        "基础教育/高等教育/职业教育教学、播控、创新实验室建设、创新课堂建设、企业培训",
    },
    {
      name: "医疗",
      content: "医疗培训、康复治疗、医学科普",
    },
    {
      name: "军警部队",
      content: "虚拟战场演习、武器装备操作训练、灾情救援仿真模拟",
    },
  ]
);

// const activeProductList = (id: number) => {
//   activeProductIndex.value = id
//   getProductsData(id)
// }

const toTop = () => {
  window.scrollTo(0, 0)
}

const toOtherPath = (url: string, titleIndex: number, pageTitle: any) => {
  router.push(url);
  store.state.titleIndex = titleIndex;
  store.state.pageTitle = [...pageTitle]
}

const selectType = (id: number) => {
  activeType.value = id;
  activeProduct.value = 0
  getProductsData(id)
}

const selectProduct = (id: number) => {
  activeProduct.value = id
  getProductsData(activeType.value, id)
}

const changeRouter = () => {
  const solutions = ['文娱解决方案', '工业解决方案', '教育解决方案', '医疗解决方案', '军警部队解决方案']
  router.push(`/solution?type=${activeSolutionsIndex.value}&pathName=解决方案,${solutions[activeSolutionsIndex.value]}`)
  store.state.programmeIndex = activeSolutionsIndex.value
  toTop()
}

onMounted(async () => {
  clearInterval(timer)
  timer = setInterval(() => {
    activeListIndex.value += 1;
    if (activeListIndex.value > 3) {
      activeListIndex.value = 0;
    }
  }, 3000)

  getProductTypes().then((res: any) => {
    getProductProfile().then((res2: any) => {
      // activeProduct.value = res2[0].brandProfileList[0].id
      res2.forEach((ele: any) => {
        if (!productTypes.value[ele.productTypeId]) {
          productTypes.value[ele.productTypeId] = { name: res[ele.productTypeId], value: [...(ele.brandProfileList || [])] }
        } else {
          productTypes.value[ele.productTypeId].push({ name: res[ele.productTypeId], value: [...(ele.brandProfileList || [])] })
        }
      });
      getProductsData(activeType.value, activeProduct.value)
    })
  })
  selectCommonElement({ columnId: 5 }).then((res: any) => {
    newsList.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0)).slice(0, 4).map((e: any) => {
      const date = new Date(e.createTime)
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      e.createTime = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`
      return e;
    })
  })

  selectCommonElement({ columnId: 1 }).then((res: any) => {
    bannerList.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0)).map((e: any) => e.ossPath)
  })

  function animate() {
    if (!document.querySelector('.cgal-img-list')) return;
    if (!stopMove.value) {
      const oldLeft = (document.querySelector('.cgal-img-list') as any)?.getBoundingClientRect().left;
      if (time == 0) {
        (document.querySelector('.cgal-img-list') as any).style.left = (oldLeft - 0.3) + 'px';
      } else {
        if (oldLeft <= -(window.innerWidth / 1920) * 2766) {
          (document.querySelector('.cgal-img-list') as any).style.left = '0px'
        } else {
          (document.querySelector('.cgal-img-list') as any).style.left = (oldLeft - 0.3 * ((new Date().getTime() - time) / 10)) + 'px';
        }
      }
    }
    // 使用requestAnimationFrame循环动画
    time = new Date().getTime()
    requestAnimationFrame(animate);
  }
  requestAnimationFrame(animate);
  if (store.state.userAgent == 'mobile') {
    (document.querySelector('.cgal-window') as any).style.overflow = 'hidden'
  }

  const qdfg: any = await asynchronousRetrieval('nfznxr-images/qdfg.png');
  const cgal_img1: any = await asynchronousRetrieval('nfznxr-images/cgal/img1.png');
  const cgal_img2: any = await asynchronousRetrieval('nfznxr-images/cgal/img2.png');
  const cgal_img3: any = await asynchronousRetrieval('nfznxr-images/cgal/img3.png');
  const cgal_img4: any = await asynchronousRetrieval('nfznxr-images/cgal/img4.png');
  const cgal_img5: any = await asynchronousRetrieval('nfznxr-images/cgal/img5.png');
  const cgal_img6: any = await asynchronousRetrieval('nfznxr-images/cgal/img6.png');
  const cgal_img7: any = await asynchronousRetrieval('nfznxr-images/cgal/img7.png');
  const cgal_img8: any = await asynchronousRetrieval('nfznxr-images/cgal/img8.png');
  const cgal_img9: any = await asynchronousRetrieval('nfznxr-images/cgal/img9.png');
  const jjfa_img1: any = await asynchronousRetrieval('nfznxr-images/jjfa/img1.png');
  const jjfa_img2: any = await asynchronousRetrieval('nfznxr-images/jjfa/img2.png');
  const jjfa_img3: any = await asynchronousRetrieval('nfznxr-images/jjfa/img3.png');
  const jjfa_img4: any = await asynchronousRetrieval('nfznxr-images/jjfa/img4.png');
  const jjfa_img5: any = await asynchronousRetrieval('nfznxr-images/jjfa/img5.png');
  loadUrl.value = { qdfg, cgal_img1, cgal_img2, cgal_img3, cgal_img4, cgal_img5, cgal_img6, cgal_img7, cgal_img8, cgal_img9, jjfa_img1, jjfa_img2, jjfa_img3, jjfa_img4, jjfa_img5 }

  solutions.value[0].url = jjfa_img1
  solutions.value[1].url = jjfa_img2
  solutions.value[2].url = jjfa_img3
  solutions.value[3].url = jjfa_img4
  solutions.value[4].url = jjfa_img5
})
const getProductsData = (productTypeId?: number | string, brandId?: number | string) => {
  getProducts({ productTypeId, brandId }).then((res: any) => {
    showProducts.value = res.records.slice(0, 4)
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (bannerList.value.length == 1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: bannerList.value[0]
          }, null, 8, _hoisted_2))
        : _createCommentVNode("", true),
      (bannerList.value.length != 1)
        ? (_openBlock(), _createBlock(_component_el_carousel, {
            key: 1,
            height: "100%",
            "pause-on-hover": false,
            interval: 10000,
            "indicator-position": _unref(store).state.userAgent == 'mobile' ? 'none' : ''
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannerList.value, (url) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, { key: url }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", { src: url }, null, 8, _hoisted_3)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["indicator-position"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "szcp title-font-style" }, "数智产品", -1)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productTypes.value, (item, id) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(activeType.value == id ? 'active' : ''),
              key: id,
              onClick: ($event: any) => (selectType(id))
            }, _toDisplayString(item.name), 11, _hoisted_7))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          (productTypes.value[activeType.value]?.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productTypes.value[activeType.value].value, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: _normalizeClass(activeProduct.value == item.id ? 'active' : ''),
                    key: index,
                    onClick: ($event: any) => (selectProduct(item.id))
                  }, _toDisplayString(item.brandName), 11, _hoisted_10))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (showProducts.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showProducts.value, (e, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  onClick: ($event: any) => (toOtherPath(`/product_detail?id=${e.id}&pathName=数智产品,${e.productTypeName},${e.productBrandName},${e.productName}`, 1, ['数智产品', e.productTypeName, e.productBrandName, e.productName]))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("img", {
                      src: e.picList[0]
                    }, null, 8, _hoisted_14)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(e.productName), 1),
                    _createElementVNode("div", null, _toDisplayString(e.productIntroduction), 1)
                  ])
                ], 8, _hoisted_12))
              }), 128)),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (toOtherPath('/product_service?pathName=产品服务,数智产品', 1, ['产品服务', '数智产品'])))
                }, [...(_cache[21] || (_cache[21] = [
                  _createElementVNode("span", null, "更多产品", -1),
                  _createElementVNode("img", { src: "/images/right-red-fine.png" }, null, -1)
                ]))])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "title-font-style" }, "渠道覆盖", -1)),
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "level2-title" }, "携手数智领域头部品牌 抢滩销量新通路", -1)),
          _createElementVNode("img", {
            src: loadUrl.value.qdfg
          }, null, 8, _hoisted_19)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[24] || (_cache[24] = _createElementVNode("div", { class: "title-font-style" }, "解决方案", -1)),
          _createElementVNode("div", {
            class: "jjfa-detail",
            style: _normalizeStyle({ background: `url(${solutions.value[activeSolutionsIndex.value].url})`, backgroundSize: '100% 100%' }),
            onClick: _withModifiers(changeRouter, ["stop"])
          }, [
            _createElementVNode("div", {
              class: "jjfa-list-box",
              onClick: _withModifiers(($event: any) => (null), ["stop"])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(solutions.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(activeSolutionsIndex.value == index ? 'active-j' : ''),
                  onClick: ($event: any) => (activeSolutionsIndex.value = index)
                }, [
                  (activeSolutionsIndex.value == index)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, _toDisplayString(item.name), 1),
                  (activeSolutionsIndex.value == index)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_23))
                    : _createCommentVNode("", true),
                  (activeSolutionsIndex.value == index)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(item.content), 1))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_21))
              }), 128))
            ])
          ], 4)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[25] || (_cache[25] = _createElementVNode("div", { class: "title-font-style" }, "成功案例", -1)),
          _createElementVNode("div", {
            class: "cgal-window",
            onMouseenter: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (stopMove.value = true), ["stop"])),
            onMouseleave: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (stopMove.value = false), ["stop"]))
          }, [
            _createElementVNode("div", {
              class: "cgal-img-list",
              onMouseenter: _withModifiers(($event: any) => (null), ["stop"]),
              onMouseleave: _withModifiers(($event: any) => (null), ["stop"])
            }, [
              _createElementVNode("div", {
                class: "box1",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_unref(router).push('/case_detail?htmlId=24&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
              }, [
                _createElementVNode("img", {
                  src: loadUrl.value.cgal_img1
                }, null, 8, _hoisted_26)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {_unref(router).push('/case_detail?htmlId=21&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
                }, [
                  _createElementVNode("img", {
                    src: loadUrl.value.cgal_img2
                  }, null, 8, _hoisted_28)
                ]),
                _createElementVNode("div", {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {_unref(router).push('/case_detail?htmlId=22&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
                }, [
                  _createElementVNode("img", {
                    src: loadUrl.value.cgal_img3
                  }, null, 8, _hoisted_29)
                ])
              ]),
              _createElementVNode("div", {
                class: "box3",
                onClick: _cache[4] || (_cache[4] = ($event: any) => {_unref(router).push('/case_detail?htmlId=14&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
              }, [
                _createElementVNode("img", {
                  src: loadUrl.value.cgal_img4
                }, null, 8, _hoisted_30)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => {_unref(router).push('/case_detail?htmlId=18&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
                }, [
                  _createElementVNode("img", {
                    src: loadUrl.value.cgal_img5
                  }, null, 8, _hoisted_32)
                ]),
                _createElementVNode("div", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => {_unref(router).push('/case_detail?htmlId=20&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
                }, [
                  _createElementVNode("img", {
                    src: loadUrl.value.cgal_img6
                  }, null, 8, _hoisted_33)
                ])
              ]),
              _createElementVNode("div", {
                class: "box5",
                onClick: _cache[7] || (_cache[7] = ($event: any) => {_unref(router).push('/case_detail?htmlId=26&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
              }, [
                _createElementVNode("img", {
                  src: loadUrl.value.cgal_img7
                }, null, 8, _hoisted_34)
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => {_unref(router).push('/case_detail?htmlId=31&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
                }, [
                  _createElementVNode("img", {
                    src: loadUrl.value.cgal_img8
                  }, null, 8, _hoisted_36)
                ]),
                _createElementVNode("div", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => {_unref(router).push('/case_detail?htmlId=25&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
                }, [
                  _createElementVNode("img", {
                    src: loadUrl.value.cgal_img9
                  }, null, 8, _hoisted_37)
                ])
              ]),
              _createElementVNode("div", {
                class: "box1",
                onClick: _cache[10] || (_cache[10] = ($event: any) => {_unref(router).push('/case_detail?htmlId=24&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
              }, [
                _createElementVNode("img", {
                  src: loadUrl.value.cgal_img1
                }, null, 8, _hoisted_38)
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => {_unref(router).push('/case_detail?htmlId=21&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
                }, [
                  _createElementVNode("img", {
                    src: loadUrl.value.cgal_img2
                  }, null, 8, _hoisted_40)
                ]),
                _createElementVNode("div", {
                  onClick: _cache[12] || (_cache[12] = ($event: any) => {_unref(router).push('/case_detail?htmlId=22&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
                }, [
                  _createElementVNode("img", {
                    src: loadUrl.value.cgal_img3
                  }, null, 8, _hoisted_41)
                ])
              ]),
              _createElementVNode("div", {
                class: "box3",
                onClick: _cache[13] || (_cache[13] = ($event: any) => {_unref(router).push('/case_detail?htmlId=14&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
              }, [
                _createElementVNode("img", {
                  src: loadUrl.value.cgal_img4
                }, null, 8, _hoisted_42)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", {
                  onClick: _cache[14] || (_cache[14] = ($event: any) => {_unref(router).push('/case_detail?htmlId=18&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
                }, [
                  _createElementVNode("img", {
                    src: loadUrl.value.cgal_img5
                  }, null, 8, _hoisted_44)
                ]),
                _createElementVNode("div", {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => {_unref(router).push('/case_detail?htmlId=20&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
                }, [
                  _createElementVNode("img", {
                    src: loadUrl.value.cgal_img6
                  }, null, 8, _hoisted_45)
                ])
              ]),
              _createElementVNode("div", {
                class: "box5",
                onClick: _cache[16] || (_cache[16] = ($event: any) => {_unref(router).push('/case_detail?htmlId=26&pathName=解决方案,应用案例,案例详情'); _unref(store).state.pageTitle = ['解决方案', '应用案例', '案例详情']})
              }, [
                _createElementVNode("img", {
                  src: loadUrl.value.cgal_img7
                }, null, 8, _hoisted_46)
              ])
            ], 32)
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_47, [
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "title-font-style" }, "开放合作", -1)),
          _createElementVNode("div", _hoisted_48, [
            _createVNode(OpenCooperation)
          ])
        ]),
        _createElementVNode("div", _hoisted_49, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "title-font-style" }, "新闻中心", -1)),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", null, [
              _createElementVNode("span", {
                onClick: _cache[19] || (_cache[19] = ($event: any) => (toOtherPath(`/about_us?pathName=关于我们,新闻动态`, 5, ['关于我们', '新闻动态'])))
              }, "更多新闻"),
              _cache[27] || (_cache[27] = _createElementVNode("img", { src: "/images/right-red-fine.png" }, null, -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", {
              onClick: _cache[20] || (_cache[20] = ($event: any) => (toOtherPath(`/news_detail?id=${newsList.value[activeListIndex.value].id}&pathName=关于我们,新闻动态,新闻详情`, 5, ['关于我们', '新闻动态', '新闻详情'])))
            }, [
              (newsList.value[activeListIndex.value])
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: newsList.value[activeListIndex.value].ossPath || ''
                  }, null, 8, _hoisted_52))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "news-title" }, "最新快讯", -1)),
              _createElementVNode("div", _hoisted_53, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsList.value, (e, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(activeListIndex.value == i ? 'active' : ''),
                    key: i,
                    onClick: ($event: any) => (toOtherPath(`/news_detail?id=${e.id}&pathName=关于我们,新闻动态,新闻详情`, 5, ['关于我们', '新闻动态', '新闻详情']))
                  }, [
                    _createElementVNode("div", null, _toDisplayString(e.title), 1),
                    _createElementVNode("div", null, _toDisplayString(e.createTime), 1)
                  ], 10, _hoisted_54))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})